import { db } from '../firebase';
import { collection, getDocs, updateDoc, doc, query, where } from 'firebase/firestore';

export async function resetTransferCounts() {
  try {
    const usersRef = collection(db, 'users');
    const usersSnapshot = await getDocs(usersRef);
    
    let updatedCount = 0;
    let skippedCount = 0;
    let errorCount = 0;
    
    for (const userDoc of usersSnapshot.docs) {
      try {
        const userData = userDoc.data();
        console.log(`Processing user: ${userData.email || userDoc.id}`);
        
        // Skip morgan.fishburne@mail.com
        if (userData.email === 'morgan.fishburne@mail.com') {
          console.log('Skipping morgan.fishburne@mail.com');
          skippedCount++;
          continue;
        }
        
        // Reset both possible field names to ensure we catch all cases
        await updateDoc(doc(db, 'users', userDoc.id), {
          transferCount: 0,
          transfers: 0,
          transfer_count: 0
        });
        
        console.log(`Reset user ${userData.email || userDoc.id} to 0 transfers`);
        updatedCount++;
      } catch (userError) {
        console.error(`Error processing user ${userDoc.id}:`, userError);
        errorCount++;
      }
    }
    
    console.log(`Reset complete: 
      ${updatedCount} users updated, 
      ${skippedCount} users skipped,
      ${errorCount} errors encountered`);
      
    return {
      success: true,
      updatedCount,
      skippedCount,
      errorCount
    };
  } catch (error) {
    console.error('Error resetting transfer counts:', error);
    return {
      success: false,
      error: error.message
    };
  }
} 